import React, { useState } from "react";
import styled from "@emotion/styled";
import { tableCellClasses } from "@mui/material";
import Colors from "assets/Style/Colors";
import { FontFamily } from "assets";
import {
  Box,
  Grid,
  Typography,
  Paper,
  IconButton,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import InputField from "components/Input";
import SelectField from "components/Select";
import Pagination from "components/Pagination";
import { PrimaryButton } from "components/Buttons";
import { useNavigate } from "react-router-dom";
import { FiDownload } from "react-icons/fi";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

const mockTickets = [
  {
    createdBy: "System Admin",
    createdOn: "7/4/2026 04:12 AM",
    ticketNo: "IT-90011-5",
    subject: "Cannot Access Email",
    description:
      "I'm unable to access my email. ",
    assignedTo: "Finance",
    type: "Complaint",
    status: "Open",
    attachment: true,
    closingRemarks: "-",
  },
  {
    createdBy: "System Admin",
    createdOn: "7/4/2026 04:12 AM",
    ticketNo: "FIN-90011-5",
    subject: "Cannot Access Email",
    description: "Cannot Access Email",
    assignedTo: "IT",
    type: "Inquiry",
    status: "Resolved",
    attachment: true,
    closingRemarks: "-",
  },
];

// Styled components for table
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    backgroundColor: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",
    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));


const SupportTickets = () => {
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("Open / Resolved");
  const [department, setDepartment] = useState("Finance/ IT");
  const [type, setType] = useState("Complaint/Inquiry/Issue");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(20);
  const totalCount = 100;
  const [activeMenu, setActiveMenu] = useState(null);
  const navigate = useNavigate();
  const [closeDialogOpen, setCloseDialogOpen] = useState(false);
  const [closingRemarks, setClosingRemarks] = useState("");
  const [selectedTicket, setSelectedTicket] = useState(null);

  return (
    <Box sx={{ p:4, pt: 6 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <Typography variant="h5"  sx={{
                      color: Colors.charcoalGrey,
                      fontFamily: FontFamily.NunitoRegular,
                      mb: 4,
                      mt: 2,
                    }}>
          Support Tickets
        </Typography>
        <PrimaryButton
          title="Create Ticket"
          bgcolor={Colors.tableGradient}
          buttonStyle={{ height: "40px", borderRadius: "8px", fontWeight: 600, minWidth: 150 }}
          onClick={() => navigate("/create-ticket")}
        />
      </Box>
      <Grid container spacing={1} alignItems="center" sx={{ mb: 2 }} justifyContent="start">
        <Grid item xs={12} sm={3}>
          <InputField
            size="small"
            label="Search"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <SelectField
            label={"Status"}
            size="small"
            options={[
            
              { id: "Open", name: "Open" },
              { id: "Resolved", name: "Resolved" },
            ]}
            selected={{ id: status, name: status }}
            onSelect={(val) => setStatus(val?.id || "")}
            register={{}}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <SelectField
            label={"Department"}
            size="small"
            options={[
           
              { id: "Finance", name: "Finance" },
              { id: "IT", name: "IT" },
            ]}
            selected={{ id: department, name: department }}
            onSelect={(val) => setDepartment(val?.id || "")}
            register={{}}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <SelectField
            label={"Type"}
            size="small"
            options={[
         
              { id: "Complaint", name: "Complaint" },
              { id: "Inquiry", name: "Inquiry" },
              { id: "Issue", name: "Issue" },
            ]}
            selected={{ id: type, name: type }}
            onSelect={(val) => setType(val?.id || "")}
            register={{}}
          />
        </Grid>
      </Grid>
      <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
        <Table stickyHeader sx={{ minWidth: 500 }}>
          <TableHead>
            <Row>
              <Cell>Created by</Cell>
              <Cell>Created on</Cell>
              <Cell>Ticket no.</Cell>
              <Cell>Subject</Cell>
              <Cell>Description</Cell>
              <Cell>Assigned to</Cell>
              <Cell>Type</Cell>
              <Cell>Status</Cell>
              <Cell>Attachment</Cell>
              <Cell>Closing Remarks</Cell>
              <Cell>Actions</Cell>
            </Row>
          </TableHead>
          <TableBody>
            {mockTickets.map((ticket, idx) => (
              <Row key={idx}>
                <Cell>{ticket.createdBy}</Cell>
                <Cell>{ticket.createdOn}</Cell>
                <Cell>{ticket.ticketNo}</Cell>
                <Cell>{ticket.subject}</Cell>
                <Cell>{ticket.description}</Cell>
                <Cell>{ticket.assignedTo}</Cell>
                <Cell>{ticket.type}</Cell>
                <Cell>
                  <Typography
                    sx={{
                      color: ticket.status === "Open" ? "#1976d2" : Colors.primary,
                    
                      cursor: ticket.status === "Open" ? "pointer" : "default",
                    }}
                  >
                    {ticket.status}
                  </Typography>
                </Cell>
                <Cell>
                  <IconButton>
                    {ticket.attachment ? (
                      <span style={{ fontSize: 32, display: 'flex', alignItems: 'center' }}>
                        <FiDownload color={Colors.primary} />
                      </span>
                    ) : (
                      <span style={{ fontSize: 32, display: 'flex', alignItems: 'center' }}>
                        <FiDownload color="gray" />
                      </span>
                    )}
                  </IconButton>
                </Cell>
                <Cell>{ticket.closingRemarks}</Cell>
                <Cell>
                  <IconButton onClick={e => setActiveMenu(ticket.ticketNo)}>
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    anchorEl={document.body}
                    open={activeMenu === ticket.ticketNo}
                    onClose={() => setActiveMenu(null)}
                    anchorReference="anchorPosition"
                    anchorPosition={activeMenu === ticket.ticketNo ? { top: window.event?.clientY || 0, left: window.event?.clientX || 0 } : undefined}
                    PaperProps={{ style: { minWidth: 150 } }}
                  >
                    <MenuItem
                      onClick={() => {
                        setActiveMenu(null);
                        // View Ticket logic here
                        alert(`View Ticket: ${ticket.ticketNo}`);
                      }}
                    >
                      View Ticket
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setActiveMenu(null);
                        setSelectedTicket(ticket);
                        setCloseDialogOpen(true);
                      }}
                    >
                      Close Ticket
                    </MenuItem>
                  </Menu>
                </Cell>
                    {/* Close Ticket Dialog */}
                    <Dialog open={closeDialogOpen} onClose={() => setCloseDialogOpen(false)} maxWidth="sm" fullWidth>
                      <DialogTitle sx={{ fontWeight: 700, textAlign: "start" }}>Close Ticket</DialogTitle>
                      <DialogContent>
                        <Box sx={{ mb: 2, textAlign: "start" }}>
                          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                            {selectedTicket?.ticketNo}
                          </Typography>
                          <Typography variant="body2" sx={{ mb: 1 }}>
                            Created on: {selectedTicket?.createdOn}
                          </Typography>
                          <Box sx={{
                            border: '1px solid #ccc',
                            borderRadius: 2,
                            p: 2,
                            mb: 2,
                            background: '#fafafa',
                            textAlign: 'left',
                          }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>Ticket Information:</Typography>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{selectedTicket?.subject}</Typography>
                            <Typography variant="body2" sx={{ mb: 1 }}>{selectedTicket?.description}</Typography>
                            <Typography variant="caption" sx={{ display: 'inline-block', mt: 1, background: '#eee', px: 1, borderRadius: 1 }}>{selectedTicket?.type}</Typography>
                          </Box>
                          <TextField
                            label="Closing Remarks*"
                            fullWidth
                            multiline
                            minRows={2}
                            maxRows={4}
                            value={closingRemarks}
                            onChange={e => setClosingRemarks(e.target.value)}
                            placeholder="Add final remarks before closing this ticket..."
                            sx={{ mt: 2 }}
                          />
                        </Box>
                      </DialogContent>
                      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
                        <Button
                          variant="contained"
                          sx={{ bgcolor: Colors.primary, color: '#fff', borderRadius: 2, px: 4, fontWeight: 700, fontSize: 16, boxShadow: 'none', '&:hover': { bgcolor: Colors.primary } }}
                          onClick={() => {
                            // Implement close ticket logic here
                            setCloseDialogOpen(false);
                            setClosingRemarks("");
                          }}
                        >
                          Close Ticket
                        </Button>
                      </DialogActions>
                    </Dialog>
              
              </Row>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        currentPage={currentPage}
        pageSize={pageLimit}
        onPageSizeChange={(e) => setPageLimit(Number(e.target.value))}
        tableCount={mockTickets.length}
        totalCount={totalCount}
        onPageChange={setCurrentPage}
      />
    </Box>
  );
};

export default SupportTickets;
